angular.module('acme.view.application.orders.modals.privateEvent.constants',[])
.constant('PRIVATE_EVENT_EXPIRE_OPTIONS',[
    {
        name: 'Event start'
    },
    {
        name: 'Purchase'
    }
])
.constant('PRIVATE_EVENT_SCHEDULE_TYPE', {
  private: {
    name: 'private'
  },
  standard: {
    name: 'standard'
  }
})
.constant('PRIVATE_EVENT_MODEL', {
    date: null,
    colorCategory: {
        textColor: '#000000',
        backgroundColor: '#d1d1d1'
    },
    durationHr: null,
    durationMin: null,
    timeHr: null,
    timeMin: null,
    timeAm: false,
    name: '',
    capacity: 100,
    priceList: null,
    discount: null,
    description: '',
    scheduleName: 'schedule_1',
    expireDays: 1,
    expireOption: 'Event start',
    emailConfirmationMessage: '',
    GLCode: null,
    emailNotify: null,
    onlinePaymentsForOrgOrdersEmailNotify: null,
})
.constant('PRIVATE_EVENT_PAYLOAD', {
    "name": "",
    "type": "private",
    "description": "",
    "emailConfirmationMessage": "",
    "emailCancellationMessage": "",
    "admissionType": "standard",
    "addOns": {},
    "images": [],
    "startTime": "",//2019-08-05T00:00:00-0700
    "endTime": null,
    "reviewState": "published",
    "schedules": [
        {
            "name": "",//schedule_1
            "description": "",//Schedule 1
            "effectiveStartTime": "",//2019-07-25T09:00:00-0700
            "hours": [
                {
                    "hour": 9,
                    "minutes": 0,
                    "quantity": 1
                }
            ],
            "days": [
                ""//2019-08-05
            ],
            "capacity": 0,
            "duration": {
                "hour": 1,
                "minutes": 0
            },
            "honorHolidays": false,
            "honorOpenHours": false
        }
    ],
    "ticketDetails": {
        "ticketDurationDays": 55,
        "expireFromEventDate": true,
        "ticketPrintLines": [
            "",
            "",
            "",
            ""
        ],
        "checkInWindow": {
            "blockScan": false,
            "minutesBefore": 30,
            "minutesAfter": 15,
            "autoRebook": false
        },
        "postStartPurchase": {
            "allowLateTicketPurchase": false,
            "minutesAfter": 0
        },
        "doNotPrint": false
    },
    "colorCategory": {
        "backgroundColor": "#ffed18",
        "textColor": "#000000"
    },
    "priceLists": [
        {
            "id": "5b69dfd9c1a3ef2067649bfc",
            "name": "Sample List",
            "description": "Aurora List",
            "prices": [
                {
                    "personType": {
                        "id": "58c1f29c79e71d020be4abd5",
                        "name": "Adult",
                        "description": "Adults age 18-65",
                        "active": true,
                        "type": "Individual",
                        "displayOrder": 0
                    },
                    "price": 10,
                    "salesChannels": [
                        {
                            "name": "Web",
                            "channel": "online",
                            "enabled": false
                        },
                        {
                            "name": "Customer Rep",
                            "channel": "customerRep",
                            "enabled": true
                        },
                        {
                            "name": "Point of Sale",
                            "channel": "pointOfSale",
                            "enabled": false
                        },
                        {
                            "name": "Manual Entry",
                            "channel": "manualEntry",
                            "enabled": true
                        },
                        {
                            "name": "Reseller",
                            "channel": "reseller",
                            "enabled": true
                        },
                        {
                            "name": "Kiosk",
                            "channel": "kiosk",
                            "enabled": false
                        }
                    ],
                    "displayOrder": 1,
                    "discountedPrice": 7,
                    "discount": 3,
                    "quantity": 0
                },
                {
                    "personType": {
                        "id": "54248ab2e4b01cd228b007a3",
                        "name": "Child",
                        "description": "12 and under",
                        "active": true,
                        "type": "Individual",
                        "displayOrder": 0
                    },
                    "price": 5,
                    "salesChannels": [
                        {
                            "name": "Web",
                            "channel": "online",
                            "enabled": false
                        },
                        {
                            "name": "Customer Rep",
                            "channel": "customerRep",
                            "enabled": true
                        },
                        {
                            "name": "Point of Sale",
                            "channel": "pointOfSale",
                            "enabled": false
                        },
                        {
                            "name": "Manual Entry",
                            "channel": "manualEntry",
                            "enabled": true
                        },
                        {
                            "name": "Reseller",
                            "channel": "reseller",
                            "enabled": true
                        },
                        {
                            "name": "Kiosk",
                            "channel": "kiosk",
                            "enabled": false
                        }
                    ],
                    "displayOrder": 2,
                    "discountedPrice": 5,
                    "discount": 0,
                    "quantity": 0
                }
            ],
            "startTime": ""//2019-08-05T11:07:43-07:00
        }
    ]
});